<template>
  <div
    class="float-menu"
    @click="processClick"
    :style="{ right: position + positionType, cursor: this.event ? 'pointer' : 'default' }"
  >
    {{ display }}
  </div>
</template>

<script>
  import EventBus from '@/EventBus';

  export default {
    name: 'FloatMenu',

    props: {
      display: {
        type: String,
        default: '→',
      },
      event: {
        type: String,
        default: null,
      },
      position: {
        type: Number,
        default: 10,
      },
      positionType: {
        type: String,
        default: 'px',
      },
    },

    methods: {
      processClick() {
        if (!this.event) return;

        EventBus.$emit(this.event);
      },
    },
  };
</script>

<style scoped lang="scss">
  $size: 20px;

  .float-menu {
    background-color: #ffffff;
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    text-align: center;
    padding: 4px;

    position: fixed;
    top: 10px;

    min-width: 22px;
    border-radius: 14px;

    z-index: 10;
  }
</style>
